document.addEventListener("DOMContentLoaded", function () {

  const sections = document.querySelectorAll(
    ".collection-list-custom-section"
  );

  sections.forEach(function (section) {

    const carousel = section.querySelector(
      ".collection-list-custom"
    );

    const nextBtn = section.querySelector(
      ".arrow-btn.next"
    );

    const prevBtn = section.querySelector(
      ".arrow-btn.prev"
    );

    if (!carousel || !nextBtn || !prevBtn) return;

    /* ========================
       Scroll amount
       ======================== */

    const getScrollAmount = function () {

      const card = carousel.querySelector(
        ".collection-card-custom"
      );

      return card
        ? card.offsetWidth + 15
        : 300;
    };

    /* ========================
       Next
       ======================== */

    nextBtn.addEventListener("click", function () {

      carousel.scrollBy({
        left: getScrollAmount(),
        behavior: "smooth"
      });

    });

    /* ========================
       Previous
       ======================== */

    prevBtn.addEventListener("click", function () {

      carousel.scrollBy({
        left: -getScrollAmount(),
        behavior: "smooth"
      });

    });

    /* ========================
       Button hover
       ======================== */

    const buttons = section.querySelectorAll(
      ".collection-btn"
    );

    buttons.forEach(function (btn) {

      const originalBg = btn.style.background;
      const originalColor = btn.style.color;

      const hoverBg = btn.dataset.hoverBg;
      const hoverColor = btn.dataset.hoverColor;

      btn.addEventListener("mouseenter", function () {

        btn.style.background = hoverBg;
        btn.style.color = hoverColor;

      });

      btn.addEventListener("mouseleave", function () {

        btn.style.background = originalBg;
        btn.style.color = originalColor;

      });

    });

  });

});